import React from 'react'
import {Button as UIButton, ButtonPriority} from 'wix-ui-tpa'
import classNames from 'classnames'
import {scheduleDataHooks as DH} from '@wix/wix-events-data-hooks'
import settingsParams, {isFullButtonStyle} from '../../../settingsParams'
import {NavigateToEventDetails} from '../../actions/navigate'
import {useSettings} from '../../../hooks/settings'
import {classes} from './button.st.css'

interface ButtonProps {
  eventDetailsUrl: string
  fullWidth?: boolean
  navigate: NavigateToEventDetails
  isSite: boolean
}

export const Button: React.FC<ButtonProps> = ({eventDetailsUrl, fullWidth, isSite, navigate}) => {
  const settings = useSettings()
  const showButton = settings.get(settingsParams.showButton)

  if (!showButton) {
    return null
  }

  const buttonStyle = settings.get(settingsParams.buttonStyle)
  const full = isFullButtonStyle(buttonStyle)

  return (
    <UIButton
      className={classNames(full ? classes.full : classes.hollow, {[classes.fullWidth]: fullWidth})}
      data-hook={DH.GET_TICKETS_BUTTON}
      upgrade
      as="a"
      href={isSite ? eventDetailsUrl : undefined}
      onClick={isSite ? null : () => navigate()}
      fullWidth={fullWidth}
      priority={full ? ButtonPriority.primary : ButtonPriority.secondary}
    >
      {settings.get(settingsParams.buttonText)}
    </UIButton>
  )
}
